// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zKdW","type":"styles_type__3yrvT","choices":"styles_choices__1hhGW"};